import React,{ useState } from 'react';
import PropTypes from 'prop-types';
import {Slide,Theme,withStyles, createStyles, makeStyles, Container, Typography, Box, Button, Dialog,IconButton,Divider,DialogActions } from "@material-ui/core";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import {useDispatch, useSelector} from "react-redux";
import {deleteExperiences} from '../../../store/actions/experience/experience';
import { TransitionProps } from '@material-ui/core/transitions';
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogContent from '@material-ui/core/DialogContent';
import {Loading} from '../../atoms/commonLoadings';


const styles = (theme: Theme) =>
  createStyles({
    tagmodalheader: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    closeButton: {
      color: theme.palette.grey[500],
      fontFamily: 'roboto-bold',
    },
    closeBtnIcon: {
      color: '#212D4080',
      width: 24,
      height: 24,
      fontFamily: 'roboto-bold'
    },
    modaltitle: {
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      color: '#212D40',
      textAlign: 'left'
    }
  });

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F0F0F0',
    paddingTop: "30px",
    fontFamily: 'roboto-regular',
    height: '100%',
    overflowX: 'hidden',
  },
  content: {
    minHeight: '100%',
    padding: theme.spacing(4),
    paddingBottom: 100,
    paddingTop: theme.spacing(6),
    '@media (min-width: 2000px)': {
      width: 1600
    },
  },
  dialogWrap: {
    margin: 'auto',
    maxWidth: 500,
    borderRadius: 14,
  },
  actionBtn: {
    textAlign: 'right',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  contentDialog: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#697683'
  },
  delBtn: {
    backgroundColor: '#ED564A',
    borderRadius: 6,
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: 'white',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#ED4F59'
    }
  },
  cancelbtn: {
    backgroundColor: '#F0F0F0',
    borderRadius: 6,
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    boxShadow: 'none',
    textTransform: 'none'
  },
  btn: {
    margin: 8
  },
  experienceName: {
    marginTop: '12px',
    fontWeight: 'bold',
    fontFamily: 'roboto-regular',
  },
}));

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogTitle = withStyles(styles)((props: any) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.tagmodalheader} {...other}>
      <Typography variant="h5" className={classes.modaltitle}>{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon classes={{ root: classes.closeBtnIcon }} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2)
  },
}))(MuiDialogContent);

DeleteExperienceModalDotMenu.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  experienceData: PropTypes.object
};

DeleteExperienceModalDotMenu.defaultProps = {
  onClose: () => {
  }
};

function DeleteExperienceModalDotMenu({open, onClose,experienceData }: any) {

  const classes = useStyles();
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [loading,setLoading]=useState(false)

  const onRemoveExperience = async () => {
    setLoading(true)
    localStorage.setItem("deleteExpId", experienceData.session_id)
    const request = { session_code: [experienceData.session_code]};
    dispatch(deleteExperiences(apolloClient.client, request, () => {onClose();setLoading(false)}))
  };

  return (
     <Dialog
        disableEscapeKeyDown
        open={open}
        TransitionComponent={Transition}
        keepMounted
        fullWidth={true}
        maxWidth={"sm"}
        classes={{
          paper: classes.dialogWrap
        }}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" onClose={()=>onClose()}>
          {"Delete Experience?"}
        </DialogTitle>
        
        <Divider />

        <DialogContent style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Container maxWidth="md">
            <Typography className={classes.contentDialog}>Are you sure you want to delete the Experience : <br /></Typography>
            <Typography className={classes.experienceName}>{experienceData && (experienceData.name)}</Typography>
            <br/>
            <Typography className={classes.contentDialog}>This operation cannot be undone.</Typography>
          </Container>
        </DialogContent>

        <DialogActions>
          <Container maxWidth="md" className={classes.actionBtn}>
            <Box display="flex" justifyContent="flex-end" alignItems="center">
              <Box mr={2}>
                <Button
                  onClick={()=>onClose()}
                  variant="contained"
                  className={classes.cancelbtn}
                >
                  Cancel
                </Button>
              </Box>
              {loading && <Loading />}
              {!loading && 
              <Button
                onClick={onRemoveExperience}
                variant="contained"
                color="secondary"
                className={classes.delBtn}
                disabled={loading}
              >
                {'Delete'}
              </Button>
              }
            </Box>
          </Container>
        </DialogActions>
      </Dialog>
  );
}

export default DeleteExperienceModalDotMenu;